var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVirtualLab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "gridItem__media",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 1600,
    height: 1200,
    viewBox: "0 0 1600 1200",
    style: {
      baselineShift: 0,
      clipRule: "nonzero",
      color: "rgb(61, 61, 61)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      cursor: "auto",
      direction: "ltr",
      display: "block",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      font: "400 16px / 18.4px Lato, sans-serif",
      imageRendering: "auto",
      letterSpacing: "normal",
      marker: "none",
      overflow: "hidden",
      paintOrder: "normal",
      pointerEvents: "auto",
      shapeRendering: "auto",
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      textAnchor: "start",
      textDecoration: "none solid rgb(61, 61, 61)",
      textRendering: "auto",
      visibility: "visible",
      wordSpacing: 0,
      writingMode: "horizontal-tb"
    },
    fill: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M337.301 1030.1L209.901 664.801C208.801 651.901 212.601 639.101 220.501 628.901L436.001 209.301C447.701 193.901 467.101 185.501 487.001 187.201L1214.5 238.901C1238.5 240.901 1258.5 257.001 1264.5 279.001L1376.5 795.701C1379 804.801 1378.9 814.401 1376.3 823.401L1277.1 1031.4L337.301 1030.1Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M337.301 1030.1L209.901 664.801C208.801 651.901 212.601 639.101 220.501 628.901L436.001 209.301C447.701 193.901 467.101 185.501 487.001 187.201L1214.5 238.901C1238.5 240.901 1258.5 257.001 1264.5 279.001L1376.5 795.701C1379 804.801 1378.9 814.401 1376.3 823.401L1277.1 1031.4L337.301 1030.1Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.598 257.901L963.798 272.601L947.398 259.401L959.198 244.701C962.698 240.401 968.998 239.701 973.398 243.101L974.098 243.701C978.398 247.201 979.098 253.501 975.598 257.901Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M975.598 257.901L963.798 272.601L947.398 259.401L959.198 244.701C962.698 240.401 968.998 239.701 973.398 243.101L974.098 243.701C978.398 247.201 979.098 253.501 975.598 257.901Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.101 241.399C966.101 241.499 968.101 242.299 969.601 243.599L970.301 244.199C974.701 247.699 975.401 253.999 971.901 258.399L961.801 270.999L963.801 272.599L975.601 257.899C979.101 253.599 978.401 247.199 974.001 243.699L973.301 243.099C970.801 241.099 967.301 240.399 964.101 241.399Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M964.101 241.399C966.101 241.499 968.101 242.299 969.601 243.599L970.301 244.199C974.701 247.699 975.401 253.999 971.901 258.399L961.801 270.999L963.801 272.599L975.601 257.899C979.101 253.599 978.401 247.199 974.001 243.699L973.301 243.099C970.801 241.099 967.301 240.399 964.101 241.399Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.6 274.2L947.4 259.5L963.8 272.7L952 287.4C948.5 291.7 942.2 292.4 937.8 289L937.1 288.4C932.8 284.9 932.1 278.6 935.6 274.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M936.5 287.8C936.7 288 936.9 288.2 937.1 288.4L937.8 289C942.1 292.5 948.5 291.8 951.9 287.4L963.7 272.7L961.7 271.1L950 285.7C946.7 289.8 940.9 290.7 936.5 287.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545 799.9L463 852.4C459.5 854.6 454.901 853.6 452.701 850.1L345 682.1C342.8 678.6 343.8 674 347.3 671.8L429.3 619.3C432.8 617.1 438.3 617.5 440.5 621L547.3 789.5C549.5 793 548.5 797.6 545 799.9Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M545 799.9L463 852.4C459.5 854.6 454.901 853.6 452.701 850.1L345 682.1C342.8 678.6 343.8 674 347.3 671.8L429.3 619.3C432.8 617.1 438.3 617.5 440.5 621L547.3 789.5C549.5 793 548.5 797.6 545 799.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.299 800.9L461.299 853.4C457.799 855.6 453.199 854.6 450.999 851.1L343.399 683.1C341.199 679.6 342.199 675 345.699 672.8L427.699 620.3C431.199 618.1 436.699 618.5 438.899 622L545.699 790.5C547.799 794.1 546.799 798.7 543.299 800.9Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M543.299 800.9L461.299 853.4C457.799 855.6 453.199 854.6 450.999 851.1L343.399 683.1C341.199 679.6 342.199 675 345.699 672.8L427.699 620.3C431.199 618.1 436.699 618.5 438.899 622L545.699 790.5C547.799 794.1 546.799 798.7 543.299 800.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.315 638.281L360.609 683.926L361.146 684.769L432.852 639.124L432.315 638.281Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.702 789.679L456.996 835.324L457.533 836.168L529.239 790.523L528.702 789.679Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.152 662.957L397.309 663.494L491.284 811.124L492.127 810.587L398.152 662.957Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.201 684.901C396.601 688.701 395.501 693.801 391.701 696.201C387.901 698.601 382.801 697.501 380.401 693.701C378.001 689.901 379.101 684.801 382.901 682.401C386.701 679.901 391.801 681.101 394.201 684.901Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M394.201 684.901C396.601 688.701 395.501 693.801 391.701 696.201C387.901 698.601 382.801 697.501 380.401 693.701C378.001 689.901 379.101 684.801 382.901 682.401C386.701 679.901 391.801 681.101 394.201 684.901Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.399 685.399C395.799 689.199 394.699 694.299 390.899 696.799C387.099 699.199 381.999 698.099 379.499 694.299C377.099 690.499 378.199 685.399 381.999 682.899C385.799 680.499 390.899 681.599 393.399 685.399Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M385.202 696.5C385.102 696.5 385.002 696.5 384.902 696.5C384.702 696.5 384.602 696.3 384.602 696.1L387.402 683.7C387.502 683.5 387.702 683.4 387.902 683.4C388.102 683.5 388.202 683.6 388.202 683.8L385.402 696.2C385.402 696.3 385.302 696.4 385.202 696.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.001 659.499C436.401 663.299 435.301 668.399 431.501 670.899C427.701 673.299 422.601 672.199 420.101 668.399C417.701 664.599 418.801 659.499 422.601 656.999C426.501 654.599 431.601 655.699 434.001 659.499Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M434.001 659.499C436.401 663.299 435.301 668.399 431.501 670.899C427.701 673.299 422.601 672.199 420.101 668.399C417.701 664.599 418.801 659.499 422.601 656.999C426.501 654.599 431.601 655.699 434.001 659.499Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.201 660.099C435.601 663.899 434.501 668.999 430.701 671.399C426.901 673.799 421.801 672.699 419.401 668.899C417.001 665.099 418.101 659.999 421.901 657.599C425.701 655.099 430.701 656.199 433.201 660.099Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M425.1 671.1C425 671.1 424.9 671.1 424.8 671.1C424.6 671.1 424.5 670.9 424.5 670.7L427.3 658.3C427.3 658.1 427.5 658 427.8 658C428 658 428.1 658.2 428.1 658.4L425.3 670.8C425.2 671 425.2 671.1 425.1 671.1Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.498 715.2C415.898 719 414.798 724.1 410.998 726.5C407.198 728.9 402.098 727.8 399.698 724C397.298 720.2 398.398 715.1 402.198 712.7C405.998 710.3 411.098 711.4 413.498 715.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M413.498 715.2C415.898 719 414.798 724.1 410.998 726.5C407.198 728.9 402.098 727.8 399.698 724C397.298 720.2 398.398 715.1 402.198 712.7C405.998 710.3 411.098 711.4 413.498 715.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.701 715.8C415.101 719.6 414.001 724.7 410.201 727.2C406.401 729.7 401.301 728.5 398.801 724.7C396.301 720.9 397.501 715.8 401.301 713.3C405.201 710.9 410.201 712 412.701 715.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M404.6 726.901C404.5 726.901 404.4 726.901 404.3 726.901C404.1 726.901 404 726.701 404 726.501L406.8 714.101C406.8 713.901 407 713.801 407.2 713.801C407.4 713.801 407.5 714.001 407.5 714.301L404.7 726.701C404.7 726.701 404.7 726.801 404.6 726.901Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.401 689.901C455.801 693.701 454.701 698.801 450.901 701.201C447.101 703.601 442.001 702.501 439.601 698.701C437.201 694.901 438.301 689.801 442.101 687.401C445.801 684.901 450.901 686.101 453.401 689.901Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M453.401 689.901C455.801 693.701 454.701 698.801 450.901 701.201C447.101 703.601 442.001 702.501 439.601 698.701C437.201 694.901 438.301 689.801 442.101 687.401C445.801 684.901 450.901 686.101 453.401 689.901Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.502 690.399C454.902 694.199 453.802 699.299 450.002 701.799C446.202 704.299 441.102 703.099 438.602 699.299C436.102 695.499 437.302 690.399 441.102 687.899C445.002 685.499 450.102 686.599 452.502 690.399Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M444.401 701.5C444.301 701.5 444.201 701.5 444.101 701.5C443.901 701.5 443.801 701.3 443.801 701.1L446.601 688.7C446.701 688.5 446.901 688.4 447.101 688.4C447.301 688.5 447.401 688.6 447.401 688.8L444.601 701.2C444.601 701.3 444.501 701.4 444.401 701.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.901 745.601C435.301 749.401 434.201 754.501 430.401 756.901C426.601 759.301 421.501 758.201 419.101 754.401C416.701 750.601 417.801 745.501 421.601 743.101C425.301 740.701 430.401 741.801 432.901 745.601Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M432.901 745.601C435.301 749.401 434.201 754.501 430.401 756.901C426.601 759.301 421.501 758.201 419.101 754.401C416.701 750.601 417.801 745.501 421.601 743.101C425.301 740.701 430.401 741.801 432.901 745.601Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.998 746.201C434.398 750.001 433.298 755.101 429.498 757.501C425.698 759.901 420.598 758.801 418.198 755.001C415.798 751.201 416.898 746.101 420.698 743.701C424.498 741.201 429.498 742.301 431.998 746.201C431.998 746.201 431.998 746.101 431.998 746.201Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M423.901 757.2C423.801 757.2 423.701 757.2 423.601 757.2C423.401 757.2 423.301 757 423.301 756.8L426.101 744.4C426.101 744.2 426.301 744.1 426.501 744.1C426.701 744.1 426.801 744.3 426.801 744.5L424.001 757C424.001 757.1 424.001 757.2 423.901 757.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.701 720.301C475.101 724.101 474.001 729.201 470.201 731.601C466.401 734.001 461.301 732.901 458.901 729.101C456.501 725.301 457.601 720.201 461.401 717.801C465.201 715.301 470.301 716.401 472.701 720.301Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M472.701 720.301C475.101 724.101 474.001 729.201 470.201 731.601C466.401 734.001 461.301 732.901 458.901 729.101C456.501 725.301 457.601 720.201 461.401 717.801C465.201 715.301 470.301 716.401 472.701 720.301Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.9 720.8C474.3 724.6 473.2 729.7 469.4 732.2C465.6 734.7 460.5 733.5 458 729.7C455.5 725.9 456.7 720.8 460.5 718.3C464.3 715.9 469.4 717 471.9 720.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M463.702 731.901C463.602 731.901 463.502 731.901 463.402 731.901C463.202 731.901 463.102 731.701 463.102 731.501L465.902 719.101C466.002 718.901 466.202 718.801 466.402 718.801C466.602 718.901 466.702 719.001 466.702 719.201L463.902 731.601C463.902 731.701 463.802 731.801 463.702 731.901Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.201 775.999C454.601 779.799 453.501 784.899 449.701 787.399C445.901 789.899 440.801 788.699 438.301 784.899C435.801 781.099 437.001 775.999 440.801 773.499C444.701 771.099 449.701 772.199 452.201 775.999Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M452.201 775.999C454.601 779.799 453.501 784.899 449.701 787.399C445.901 789.899 440.801 788.699 438.301 784.899C435.801 781.099 437.001 775.999 440.801 773.499C444.701 771.099 449.701 772.199 452.201 775.999Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.401 776.499C453.801 780.299 452.701 785.399 448.901 787.799C445.101 790.199 440.001 789.099 437.601 785.299C435.201 781.499 436.301 776.399 440.101 773.999C443.801 771.599 448.901 772.699 451.401 776.499C451.301 776.499 451.301 776.499 451.401 776.499Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M443.202 787.6C443.102 787.6 443.002 787.6 442.902 787.6C442.702 787.6 442.602 787.4 442.602 787.1L445.402 774.7C445.402 774.5 445.602 774.4 445.902 774.4C446.102 774.4 446.202 774.6 446.202 774.9L443.402 787.3C443.402 787.4 443.302 787.5 443.202 787.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.998 750.601C494.398 754.401 493.298 759.501 489.498 761.901C485.698 764.301 480.598 763.201 478.198 759.401C475.798 755.601 476.898 750.501 480.698 748.101C484.498 745.701 489.598 746.801 491.998 750.601Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M491.998 750.601C494.398 754.401 493.298 759.501 489.498 761.901C485.698 764.301 480.598 763.201 478.198 759.401C475.798 755.601 476.898 750.501 480.698 748.101C484.498 745.701 489.598 746.801 491.998 750.601Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.201 751.201C493.601 755.001 492.501 760.101 488.701 762.501C484.901 764.901 479.801 763.801 477.401 760.001C475.001 756.201 476.101 751.101 479.901 748.701C483.601 746.201 488.701 747.301 491.201 751.201Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M483.1 762.2C483 762.2 482.9 762.2 482.8 762.2C482.6 762.2 482.5 762 482.5 761.8L485.3 749.4C485.3 749.2 485.5 749.1 485.7 749.1C485.9 749.1 486 749.3 486 749.6L483.2 762.1C483.2 762.1 483.2 762.2 483.1 762.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.502 806.4C473.902 810.2 472.802 815.3 469.002 817.8C465.202 820.3 460.102 819.1 457.602 815.3C455.102 811.5 456.302 806.4 460.102 803.9C464.002 801.4 469.102 802.5 471.502 806.4Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M471.502 806.4C473.902 810.2 472.802 815.3 469.002 817.8C465.202 820.3 460.102 819.1 457.602 815.3C455.102 811.5 456.302 806.4 460.102 803.9C464.002 801.4 469.102 802.5 471.502 806.4Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.701 806.899C473.101 810.699 472.001 815.799 468.201 818.199C464.401 820.599 459.301 819.499 456.901 815.699C454.501 811.899 455.601 806.799 459.401 804.399C463.201 801.999 468.201 803.099 470.701 806.899Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M462.6 818.001C462.5 818.001 462.4 818.001 462.3 818.001C462.1 818.001 462 817.801 462 817.501L464.8 805.101C464.8 804.901 465 804.801 465.3 804.801C465.5 804.801 465.6 805.001 465.6 805.301L462.8 817.701C462.7 817.801 462.7 817.901 462.6 818.001Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.401 780.999C513.801 784.799 512.701 789.899 508.901 792.299C505.101 794.699 500.001 793.599 497.601 789.799C495.201 785.999 496.301 780.899 500.101 778.499C503.801 776.099 508.901 777.199 511.401 780.999C511.401 780.999 511.301 780.999 511.401 780.999Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M511.401 780.999C513.801 784.799 512.701 789.899 508.901 792.299C505.101 794.699 500.001 793.599 497.601 789.799C495.201 785.999 496.301 780.899 500.101 778.499C503.801 776.099 508.901 777.199 511.401 780.999C511.401 780.999 511.301 780.999 511.401 780.999Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.498 781.499C512.898 785.299 511.798 790.399 507.998 792.799C504.198 795.199 499.098 794.099 496.698 790.299C494.298 786.499 495.398 781.399 499.198 778.999C502.998 776.599 508.098 777.699 510.498 781.499Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M502.401 792.6C502.301 792.6 502.201 792.6 502.101 792.6C501.901 792.6 501.801 792.4 501.801 792.1L504.601 779.7C504.601 779.5 504.801 779.4 505.101 779.4C505.301 779.4 505.401 779.6 505.401 779.9L502.601 792.3C502.601 792.4 502.501 792.5 502.401 792.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.1 716L1014.1 671.4C1009.6 669.5 1007.4 664.8 1009.1 660.8L1090.4 469.4C1092.1 465.4 1097.1 463.8 1101.5 465.6L1206.5 510.2C1211 512.1 1214.3 517.3 1212.6 521.3L1130.2 712.3C1128.5 716.3 1123.5 717.9 1119.1 716Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1119.1 716L1014.1 671.4C1009.6 669.5 1007.4 664.8 1009.1 660.8L1090.4 469.4C1092.1 465.4 1097.1 463.8 1101.5 465.6L1206.5 510.2C1211 512.1 1214.3 517.3 1212.6 521.3L1130.2 712.3C1128.5 716.3 1123.5 717.9 1119.1 716Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.9 715.099L1011.9 670.499C1007.4 668.599 1005.2 663.899 1006.9 659.899L1088.2 468.499C1089.9 464.499 1094.9 462.899 1099.3 464.699L1204.3 509.299C1208.7 511.199 1212.1 516.399 1210.4 520.399L1128 711.399C1126.3 715.299 1121.4 716.999 1116.9 715.099Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1116.9 715.099L1011.9 670.499C1007.4 668.599 1005.2 663.899 1006.9 659.899L1088.2 468.499C1089.9 464.499 1094.9 462.899 1099.3 464.699L1204.3 509.299C1208.7 511.199 1212.1 516.399 1210.4 520.399L1128 711.399C1126.3 715.299 1121.4 716.999 1116.9 715.099Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.67 486.6L1098.2 487.703L1189.67 526.856L1190.14 525.753L1098.67 486.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.09 653.954L1026.61 655.057L1118.08 694.21L1118.56 693.107L1027.09 653.954Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.68 508.685L1073.11 671.217L1074.21 671.689L1143.78 509.157L1142.68 508.685Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.6 528.3L1103.9 525L1107.6 516.4L1115.3 519.7C1117.6 520.7 1118.6 523.3 1117.7 525.6L1117.5 526C1116.5 528.2 1113.9 529.3 1111.6 528.3Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1111.6 528.3L1103.9 525L1107.6 516.4L1115.3 519.7C1117.6 520.7 1118.6 523.3 1117.7 525.6L1117.5 526C1116.5 528.2 1113.9 529.3 1111.6 528.3Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.2 521.5C1117.4 522.4 1117.3 523.3 1116.9 524.1L1116.7 524.5C1115.7 526.8 1113.1 527.8 1110.8 526.9L1104.2 524.1L1103.7 525.2L1111.4 528.5C1113.7 529.5 1116.3 528.4 1117.3 526.2L1117.5 525.8C1118.2 524.3 1118 522.7 1117.2 521.5Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.7 513.199L1107.4 516.499L1103.7 525.099L1096 521.799C1093.7 520.799 1092.7 518.199 1093.6 515.899L1093.8 515.499C1094.9 513.199 1097.5 512.199 1099.7 513.199Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1094.1 515.199C1094 515.299 1094 515.399 1093.9 515.499L1093.7 515.899C1092.7 518.199 1093.8 520.799 1096 521.799L1103.7 525.099L1104.2 523.999L1096.5 520.699C1094.4 519.799 1093.3 517.399 1094.1 515.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.6 556.301L1091.9 553.001L1095.6 544.301L1103.3 547.601C1105.6 548.601 1106.6 551.201 1105.7 553.501L1105.5 553.901C1104.6 556.201 1101.9 557.301 1099.6 556.301Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1099.6 556.301L1091.9 553.001L1095.6 544.301L1103.3 547.601C1105.6 548.601 1106.6 551.201 1105.7 553.501L1105.5 553.901C1104.6 556.201 1101.9 557.301 1099.6 556.301Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.3 549.5C1105.5 550.4 1105.4 551.3 1105 552.1L1104.8 552.5C1103.8 554.8 1101.2 555.8 1098.9 554.9L1092.3 552.1L1091.8 553.2L1099.5 556.5C1101.8 557.5 1104.4 556.4 1105.4 554.1L1105.6 553.7C1106.2 552.3 1106.1 550.7 1105.3 549.5Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.4 537.8L1098.1 541.1L1094.4 549.7L1086.7 546.4C1084.4 545.4 1083.4 542.8 1084.3 540.5L1084.5 540.1C1085.5 537.9 1088.1 536.8 1090.4 537.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1082.1 543.199C1082 543.299 1082 543.399 1081.9 543.499L1081.7 543.899C1080.7 546.199 1081.8 548.799 1084.1 549.799L1091.8 553.099L1092.3 551.999L1084.6 548.699C1082.5 547.699 1081.4 545.399 1082.1 543.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.6 584.3L1079.9 581L1083.6 572.4L1091.3 575.7C1093.6 576.7 1094.6 579.3 1093.7 581.6L1093.5 582C1092.5 584.2 1089.9 585.3 1087.6 584.3Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1087.6 584.3L1079.9 581L1083.6 572.4L1091.3 575.7C1093.6 576.7 1094.6 579.3 1093.7 581.6L1093.5 582C1092.5 584.2 1089.9 585.3 1087.6 584.3Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.3 577.4C1093.5 578.3 1093.4 579.2 1093 580L1092.8 580.4C1091.8 582.7 1089.2 583.7 1086.9 582.8L1080.3 580L1079.8 581.1L1087.5 584.4C1089.8 585.4 1092.4 584.3 1093.4 582L1093.6 581.6C1094.2 580.2 1094.1 578.7 1093.3 577.4Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.8 569.099L1083.5 572.399L1079.8 580.999L1072.1 577.699C1069.8 576.699 1068.8 574.099 1069.7 571.799L1069.9 571.399C1070.9 569.199 1073.5 568.199 1075.8 569.099Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1070.1 571.1C1070 571.2 1070 571.3 1069.9 571.4L1069.7 571.8C1068.7 574.1 1069.8 576.7 1072 577.7L1079.7 581L1080.2 579.9L1072.5 576.6C1070.5 575.7 1069.4 573.3 1070.1 571.1Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.6 612.3L1067.9 609L1071.6 600.4L1079.3 603.7C1081.6 604.7 1082.6 607.3 1081.7 609.6L1081.5 610C1080.5 612.2 1077.9 613.3 1075.6 612.3Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1075.6 612.3L1067.9 609L1071.6 600.4L1079.3 603.7C1081.6 604.7 1082.6 607.3 1081.7 609.6L1081.5 610C1080.5 612.2 1077.9 613.3 1075.6 612.3Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.3 605.4C1081.5 606.3 1081.4 607.2 1081 608L1080.8 608.4C1079.8 610.7 1077.2 611.7 1074.9 610.7L1068.3 607.9L1067.8 609L1075.5 612.3C1077.8 613.3 1080.4 612.2 1081.4 610L1081.6 609.6C1082.2 608.2 1082.1 606.7 1081.3 605.4Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.6 593.799L1074.3 597.099L1070.6 605.699L1062.9 602.399C1060.6 601.399 1059.6 598.799 1060.5 596.499L1060.6 596.199C1061.7 593.999 1064.3 592.899 1066.6 593.799Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1058.2 599.1C1058.1 599.2 1058.1 599.3 1058 599.4L1057.8 599.8C1056.8 602.1 1057.9 604.7 1060.2 605.7L1067.9 609L1068.4 607.9L1060.7 604.6C1058.5 603.7 1057.4 601.3 1058.2 599.1Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.7 640.3L1056 637L1059.7 628.4L1067.4 631.7C1069.7 632.7 1070.7 635.3 1069.8 637.6L1069.6 638C1068.6 640.2 1065.9 641.2 1063.7 640.3Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1063.7 640.3L1056 637L1059.7 628.4L1067.4 631.7C1069.7 632.7 1070.7 635.3 1069.8 637.6L1069.6 638C1068.6 640.2 1065.9 641.2 1063.7 640.3Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.3 633.4C1069.5 634.3 1069.4 635.2 1069 636L1068.8 636.4C1067.8 638.7 1065.2 639.7 1062.9 638.8L1056.2 636L1055.7 637.1L1063.4 640.4C1065.7 641.4 1068.3 640.3 1069.3 638.1L1069.5 637.7C1070.3 636.2 1070.1 634.6 1069.3 633.4Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.9 625.101L1059.6 628.401L1055.9 637.001L1048.2 633.701C1045.9 632.701 1044.9 630.101 1045.8 627.801L1045.9 627.501C1046.9 625.201 1049.5 624.101 1051.9 625.101C1051.8 625.101 1051.8 625.101 1051.9 625.101Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1046.2 627.1C1046.1 627.2 1046.1 627.3 1046 627.4L1045.8 627.8C1044.8 630.1 1045.9 632.7 1048.2 633.7L1055.9 637L1056.4 635.9L1048.7 632.6C1046.5 631.7 1045.4 629.3 1046.2 627.1Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.4 551.8L1158.7 548.5L1162.4 539.9L1170.1 543.2C1172.4 544.2 1173.5 546.8 1172.5 549.1L1172.3 549.5C1171.4 551.7 1168.8 552.8 1166.4 551.8C1166.5 551.8 1166.5 551.8 1166.4 551.8Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1166.4 551.8L1158.7 548.5L1162.4 539.9L1170.1 543.2C1172.4 544.2 1173.5 546.8 1172.5 549.1L1172.3 549.5C1171.4 551.7 1168.8 552.8 1166.4 551.8C1166.5 551.8 1166.5 551.8 1166.4 551.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.1 545C1172.3 545.9 1172.2 546.8 1171.8 547.6L1171.6 548C1170.6 550.3 1168 551.3 1165.7 550.4L1159.1 547.6L1158.6 548.7L1166.3 552C1168.6 553 1171.2 551.9 1172.2 549.7L1172.4 549.3C1173 547.8 1172.9 546.3 1172.1 545Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.6 536.599L1162.3 539.899L1158.6 548.499L1150.9 545.199C1148.6 544.199 1147.6 541.599 1148.5 539.299L1148.7 538.899C1149.7 536.699 1152.4 535.699 1154.6 536.599Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1149 538.699C1148.9 538.799 1148.9 538.899 1148.8 538.999L1148.6 539.399C1147.6 541.699 1148.7 544.299 1150.9 545.299L1158.6 548.599L1159.1 547.499L1151.4 544.199C1149.3 543.299 1148.3 540.899 1149 538.699Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.5 579.8L1146.8 576.5L1150.5 567.9L1158.2 571.2C1160.5 572.1 1161.6 574.8 1160.6 577.1L1160.4 577.5C1159.5 579.7 1156.8 580.8 1154.5 579.8Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1154.5 579.8L1146.8 576.5L1150.5 567.9L1158.2 571.2C1160.5 572.1 1161.6 574.8 1160.6 577.1L1160.4 577.5C1159.5 579.7 1156.8 580.8 1154.5 579.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160.1 572.9C1160.3 573.8 1160.2 574.7 1159.8 575.5L1159.6 575.9C1158.6 578.2 1156 579.2 1153.7 578.3L1147.1 575.5L1146.6 576.6L1154.3 579.9C1156.6 580.9 1159.2 579.8 1160.2 577.5L1160.4 577.1C1161.1 575.7 1160.9 574.2 1160.1 572.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.7 564.599L1150.4 567.899L1146.7 576.499L1139 573.199C1136.7 572.199 1135.7 569.599 1136.6 567.299L1136.8 566.899C1137.7 564.699 1140.4 563.699 1142.7 564.599Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1137 566.6C1136.9 566.7 1136.9 566.8 1136.8 566.9L1136.6 567.3C1135.6 569.6 1136.7 572.2 1139 573.2L1146.7 576.5L1147.2 575.4L1139.5 572.1C1137.3 571.2 1136.3 568.8 1137 566.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.5 607.8L1134.7 604.5L1138.4 595.9L1146.1 599.2C1148.4 600.2 1149.4 602.8 1148.5 605.1L1148.3 605.5C1147.4 607.7 1144.8 608.7 1142.5 607.8Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1142.5 607.8L1134.7 604.5L1138.4 595.9L1146.1 599.2C1148.4 600.2 1149.4 602.8 1148.5 605.1L1148.3 605.5C1147.4 607.7 1144.8 608.7 1142.5 607.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.2 600.9C1148.4 601.8 1148.3 602.7 1147.9 603.5L1147.7 603.9C1146.7 606.2 1144.1 607.2 1141.8 606.3L1135.2 603.5L1134.7 604.6L1142.4 607.9C1144.7 608.9 1147.3 607.8 1148.3 605.5L1148.5 605.1C1149.1 603.7 1149 602.2 1148.2 600.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.7 592.599L1138.4 595.899L1134.7 604.499L1127 601.199C1124.7 600.199 1123.7 597.599 1124.6 595.299L1124.8 594.899C1125.8 592.699 1128.4 591.699 1130.7 592.599Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1125 594.6C1124.9 594.7 1124.9 594.8 1124.8 594.9L1124.6 595.3C1123.6 597.6 1124.7 600.2 1126.9 601.2L1134.6 604.5L1135.1 603.4L1127.4 600.1C1125.3 599.2 1124.3 596.8 1125 594.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.5 635.8L1122.8 632.5L1126.5 623.9L1134.2 627.2C1136.5 628.2 1137.5 630.8 1136.6 633.1L1136.4 633.5C1135.4 635.7 1132.8 636.8 1130.5 635.8Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1130.5 635.8L1122.8 632.5L1126.5 623.9L1134.2 627.2C1136.5 628.2 1137.5 630.8 1136.6 633.1L1136.4 633.5C1135.4 635.7 1132.8 636.8 1130.5 635.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.2 628.9C1136.4 629.8 1136.3 630.7 1135.9 631.5L1135.7 631.9C1134.7 634.2 1132.1 635.2 1129.8 634.3L1123.2 631.5L1122.7 632.6L1130.4 635.9C1132.7 636.9 1135.3 635.8 1136.3 633.5L1136.5 633.1C1137.1 631.7 1137 630.2 1136.2 628.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.7 620.599L1126.4 623.899L1122.7 632.499L1115 629.199C1112.7 628.199 1111.7 625.599 1112.6 623.299L1112.8 622.899C1113.8 620.699 1116.4 619.699 1118.7 620.599Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1113.1 622.6C1113 622.7 1113 622.8 1112.9 622.9L1112.7 623.3C1111.7 625.6 1112.8 628.2 1115.1 629.2L1122.8 632.5L1123.3 631.4L1115.6 628.1C1113.4 627.2 1112.3 624.8 1113.1 622.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.5 663.8L1110.8 660.5L1114.5 651.9L1122.2 655.2C1124.5 656.2 1125.5 658.8 1124.6 661.1L1124.4 661.5C1123.5 663.7 1120.8 664.8 1118.5 663.8Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1118.5 663.8L1110.8 660.5L1114.5 651.9L1122.2 655.2C1124.5 656.2 1125.5 658.8 1124.6 661.1L1124.4 661.5C1123.5 663.7 1120.8 664.8 1118.5 663.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.2 656.9C1124.4 657.8 1124.3 658.7 1123.9 659.5L1123.7 659.9C1122.7 662.2 1120.1 663.2 1117.8 662.3L1111.2 659.5L1110.7 660.6L1118.4 663.9C1120.7 664.9 1123.3 663.8 1124.3 661.6L1124.5 661.2C1125.1 659.7 1125 658.1 1124.2 656.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1117.2 521.5C1117.4 522.4 1117.3 523.3 1116.9 524.1L1116.7 524.5C1115.7 526.8 1113.1 527.8 1110.8 526.9L1104.2 524.1L1103.7 525.2L1111.4 528.5C1113.7 529.5 1116.3 528.4 1117.3 526.2L1117.5 525.8C1118.2 524.3 1118 522.7 1117.2 521.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1105.3 549.5C1105.5 550.4 1105.4 551.3 1105 552.1L1104.8 552.5C1103.8 554.8 1101.2 555.8 1098.9 554.9L1092.3 552.1L1091.8 553.2L1099.5 556.5C1101.8 557.5 1104.4 556.4 1105.4 554.1L1105.6 553.7C1106.2 552.3 1106.1 550.7 1105.3 549.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1093.3 577.4C1093.5 578.3 1093.4 579.2 1093 580L1092.8 580.4C1091.8 582.7 1089.2 583.7 1086.9 582.8L1080.3 580L1079.8 581.1L1087.5 584.4C1089.8 585.4 1092.4 584.3 1093.4 582L1093.6 581.6C1094.2 580.2 1094.1 578.7 1093.3 577.4Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1081.3 605.4C1081.5 606.3 1081.4 607.2 1081 608L1080.8 608.4C1079.8 610.7 1077.2 611.7 1074.9 610.7L1068.3 607.9L1067.8 609L1075.5 612.3C1077.8 613.3 1080.4 612.2 1081.4 610L1081.6 609.6C1082.2 608.2 1082.1 606.7 1081.3 605.4Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1069.3 633.4C1069.5 634.3 1069.4 635.2 1069 636L1068.8 636.4C1067.8 638.7 1065.2 639.7 1062.9 638.8L1056.2 636L1055.7 637.1L1063.4 640.4C1065.7 641.4 1068.3 640.3 1069.3 638.1L1069.5 637.7C1070.3 636.2 1070.1 634.6 1069.3 633.4Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1172.1 545C1172.3 545.9 1172.2 546.8 1171.8 547.6L1171.6 548C1170.6 550.3 1168 551.3 1165.7 550.4L1159.1 547.6L1158.6 548.7L1166.3 552C1168.6 553 1171.2 551.9 1172.2 549.7L1172.4 549.3C1173 547.8 1172.9 546.3 1172.1 545Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1160.1 572.9C1160.3 573.8 1160.2 574.7 1159.8 575.5L1159.6 575.9C1158.6 578.2 1156 579.2 1153.7 578.3L1147.1 575.5L1146.6 576.6L1154.3 579.9C1156.6 580.9 1159.2 579.8 1160.2 577.5L1160.4 577.1C1161.1 575.7 1160.9 574.2 1160.1 572.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1148.2 600.9C1148.4 601.8 1148.3 602.7 1147.9 603.5L1147.7 603.9C1146.7 606.2 1144.1 607.2 1141.8 606.3L1135.2 603.5L1134.7 604.6L1142.4 607.9C1144.7 608.9 1147.3 607.8 1148.3 605.5L1148.5 605.1C1149.1 603.7 1149 602.2 1148.2 600.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1136.2 628.9C1136.4 629.8 1136.3 630.7 1135.9 631.5L1135.7 631.9C1134.7 634.2 1132.1 635.2 1129.8 634.3L1123.2 631.5L1122.7 632.6L1130.4 635.9C1132.7 636.9 1135.3 635.8 1136.3 633.5L1136.5 633.1C1137.1 631.7 1137 630.2 1136.2 628.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1124.2 656.9C1124.4 657.8 1124.3 658.7 1123.9 659.5L1123.7 659.9C1122.7 662.2 1120.1 663.2 1117.8 662.3L1111.2 659.5L1110.7 660.6L1118.4 663.9C1120.7 664.9 1123.3 663.8 1124.3 661.6L1124.5 661.2C1125.1 659.7 1125 658.1 1124.2 656.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.7 648.599L1114.4 651.899L1110.7 660.499L1103 657.199C1100.7 656.199 1099.7 653.599 1100.6 651.299L1100.8 650.899C1101.8 648.699 1104.4 647.699 1106.7 648.599Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1101.1 650.6C1101 650.7 1101 650.8 1100.9 650.9L1100.7 651.3C1099.7 653.6 1100.8 656.2 1103 657.2L1110.7 660.5L1111.2 659.4L1103.5 656.1C1101.4 655.2 1100.3 652.8 1101.1 650.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332.4 1033.2H278.4C277.6 1033.3 276.8 1032.8 276.7 1031.9C276.6 1031.1 277.1 1030.3 278 1030.2C278.2 1030.2 278.3 1030.2 278.5 1030.2H1332.5C1333.3 1030.3 1333.9 1031.1 1333.8 1031.9C1333.5 1032.6 1333 1033.1 1332.4 1033.2Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1332.4 1033.2H278.4C277.6 1033.3 276.8 1032.8 276.7 1031.9C276.6 1031.1 277.1 1030.3 278 1030.2C278.2 1030.2 278.3 1030.2 278.5 1030.2H1332.5C1333.3 1030.3 1333.9 1031.1 1333.8 1031.9C1333.5 1032.6 1333 1033.1 1332.4 1033.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.498 342.699H1031.1C1037.8 342.699 1043.2 348.099 1043.2 354.799V904.999C1043.2 911.699 1037.8 917.099 1031.1 917.099H640.498C633.798 917.099 628.398 911.699 628.398 904.999V354.799C628.398 348.099 633.798 342.699 640.498 342.699Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.498 342.699H1025C1031.7 342.699 1037.1 348.099 1037.1 354.799V904.999C1037.1 911.699 1031.7 917.099 1025 917.099H634.498C627.798 917.099 622.398 911.699 622.398 904.999V354.799C622.398 348.099 627.798 342.699 634.498 342.699Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M634.498 342.699H1025C1031.7 342.699 1037.1 348.099 1037.1 354.799V904.999C1037.1 911.699 1031.7 917.099 1025 917.099H634.498C627.798 917.099 622.398 911.699 622.398 904.999V354.799C622.398 348.099 627.798 342.699 634.498 342.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1015.3 370.4H659V893.4H1015.3V370.4Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.4 372.199H654.102V885.199H1010.4V372.199Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1010.4 372.199H654.102V885.199H1010.4V372.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.4 369.801H648.102V882.801H1004.4V369.801Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.8 371.5C814.3 371.5 798.5 355.7 798.5 336.3C798.5 316.9 814.3 301 833.7 301C853.1 301 869 316.8 869 336.2C869 355.7 853.2 371.5 833.8 371.5ZM833.8 319.1C824.3 319.1 816.7 326.8 816.7 336.2C816.7 345.6 824.4 353.3 833.8 353.3C843.2 353.3 850.9 345.6 850.9 336.2C850.9 326.8 843.2 319.1 833.8 319.1Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M833.8 371.5C814.3 371.5 798.5 355.7 798.5 336.3C798.5 316.9 814.3 301 833.7 301C853.1 301 869 316.8 869 336.2C869 355.7 853.2 371.5 833.8 371.5ZM833.8 319.1C824.3 319.1 816.7 326.8 816.7 336.2C816.7 345.6 824.4 353.3 833.8 353.3C843.2 353.3 850.9 345.6 850.9 336.2C850.9 326.8 843.2 319.1 833.8 319.1Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.801 343.9V385.3C706.801 388.6 709.501 391.3 712.801 391.3H954.201C957.501 391.3 960.201 388.6 960.201 385.3V344C960.201 340.7 957.501 338 954.201 338H712.801C709.501 338 706.901 340.7 706.801 343.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M706.801 343.9V385.3C706.801 388.6 709.501 391.3 712.801 391.3H954.201C957.501 391.3 960.201 388.6 960.201 385.3V344C960.201 340.7 957.501 338 954.201 338H712.801C709.501 338 706.901 340.7 706.801 343.9Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702 343.9V385.3C702 388.6 704.7 391.3 708 391.3H949.4C952.7 391.3 955.4 388.7 955.4 385.4C955.4 385.4 955.4 385.4 955.4 385.3V344C955.4 340.7 952.7 338 949.4 338H708.1C704.7 338 702 340.6 702 343.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M702 343.9V385.3C702 388.6 704.7 391.3 708 391.3H949.4C952.7 391.3 955.4 388.7 955.4 385.4C955.4 385.4 955.4 385.4 955.4 385.3V344C955.4 340.7 952.7 338 949.4 338H708.1C704.7 338 702 340.6 702 343.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.902 371.5C809.402 371.5 793.602 355.7 793.602 336.2C793.602 316.7 809.402 300.9 828.902 300.9C848.402 300.9 864.202 316.7 864.202 336.2C864.202 355.7 848.402 371.5 828.902 371.5ZM828.902 319.1C819.402 319.1 811.802 326.8 811.802 336.2C811.802 345.6 819.502 353.3 828.902 353.3C838.302 353.3 846.002 345.6 846.002 336.2C846.102 326.8 838.402 319.1 828.902 319.1Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M828.902 371.5C809.402 371.5 793.602 355.7 793.602 336.2C793.602 316.7 809.402 300.9 828.902 300.9C848.402 300.9 864.202 316.7 864.202 336.2C864.202 355.7 848.402 371.5 828.902 371.5ZM828.902 319.1C819.402 319.1 811.802 326.8 811.802 336.2C811.802 345.6 819.502 353.3 828.902 353.3C838.302 353.3 846.002 345.6 846.002 336.2C846.102 326.8 838.402 319.1 828.902 319.1Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.202 425.9H674.102V479.7H707.202V425.9Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M707.202 425.9H674.102V479.7H707.202V425.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M740.301 479.6H707.301V425.9H740.301V479.6ZM708.501 478.3H738.901V427.2H708.501V478.3Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M707.199 479.6H674.199V425.9H707.199V479.6ZM675.499 478.3H705.899V427.2H675.499V478.3Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M702.399 452.7L702.299 471.3C691.999 471.3 683.699 462.9 683.699 452.6C683.699 442.3 692.099 434 702.399 434V452.7Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.398 453.399L713.498 471.999C723.798 471.999 732.098 463.599 732.098 453.299C732.098 442.999 723.698 434.699 713.398 434.699V453.399Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M713.398 453.399L713.498 471.999C723.798 471.999 732.098 463.599 732.098 453.299C732.098 442.999 723.698 434.699 713.398 434.699V453.399Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.998 431.199H755.898V439.699H899.998V431.199Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M899.998 431.199H755.898V439.699H899.998V431.199Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.302 453H756.102V456.6H789.302V453Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.302 467.5H756.102V471.1H789.302V467.5Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864 453H800V456.6H864V453Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864 467.5H800V471.1H864V467.5Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.499 453H937.699V456.6H982.499V453Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.499 467.5H937.699V471.1H982.499V467.5Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.702 451.5H793.602V453.6H795.702V451.5Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.702 455.699H793.602V457.799H795.702V455.699Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.702 466.4H793.602V468.5H795.702V466.4Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.702 470.699H793.602V472.799H795.702V470.699Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.899 453H892.699V456.6H925.899V453Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.899 467.5H892.699V471.1H925.899V467.5Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.299 451.5H930.199V453.6H932.299V451.5Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.299 455.699H930.199V457.799H932.299V455.699Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.299 466.4H930.199V468.5H932.299V466.4Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.299 470.699H930.199V472.799H932.299V470.699Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.498 504.299H664.498C664.198 504.299 663.898 504.099 663.898 503.799C663.898 503.499 664.098 503.199 664.398 503.199H664.498H991.498C991.798 503.199 991.998 503.499 991.998 503.799C991.898 503.999 991.698 504.199 991.498 504.299Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.7 818H664.5C664.2 818 664 817.7 664 817.4C664 817.2 664.2 817 664.5 816.9H977.7C978 816.9 978.2 817.2 978.2 817.5C978.1 817.8 977.9 818 977.7 818Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.801 529.301H673.801V535.701H763.801V529.301Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M763.699 529.301H673.699V535.701H763.699V529.301Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.998 550.199H673.898V553.799H942.998V550.199Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.898 564.699H673.898V568.299H781.898V564.699Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.199 564.699H789.199V568.299H897.199V564.699Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.801 596.6H673.801V603H763.801V596.6Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M763.699 596.6H673.699V603H763.699V596.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.998 617.4H673.898V621H942.998V617.4Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.798 631.9H673.898V635.5H843.798V631.9Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.801 663.801H673.801V670.201H763.801V663.801Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M763.699 663.801H673.699V670.201H763.699V663.801Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.998 684.6H673.898V688.2H942.998V684.6Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.198 835.6H684.398V846.3H723.198V835.6Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M723.198 835.6H684.398V846.3H723.198V835.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.801 839.301H732.801V842.901H796.801V839.301Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.601 835.6H848.801V846.3H887.601V835.6Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M887.499 835.6H848.699V846.3H887.499V835.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.102 839.301H897.102V842.901H944.102V839.301Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.898 699.1H673.898V702.7H718.898V699.1Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.101 699.1H725.301V702.7H897.101V699.1Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M789.302 453H756.102V456.6H789.302V453Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M789.302 467.5H756.102V471.1H789.302V467.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M864 453H800V456.6H864V453Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M864 467.5H800V471.1H864V467.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M982.499 453H937.699V456.6H982.499V453Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M982.499 467.5H937.699V471.1H982.499V467.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M795.702 451.5H793.602V453.6H795.702V451.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M795.702 455.699H793.602V457.799H795.702V455.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M795.702 466.4H793.602V468.5H795.702V466.4Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M795.702 470.699H793.602V472.799H795.702V470.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M925.899 453H892.699V456.6H925.899V453Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M925.899 467.5H892.699V471.1H925.899V467.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M932.299 451.5H930.199V453.6H932.299V451.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M932.299 455.699H930.199V457.799H932.299V455.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M932.299 466.4H930.199V468.5H932.299V466.4Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M932.299 470.699H930.199V472.799H932.299V470.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M942.998 550.199H673.898V553.799H942.998V550.199Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M781.898 564.699H673.898V568.299H781.898V564.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M897.199 564.699H789.199V568.299H897.199V564.699Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M942.998 617.4H673.898V621H942.998V617.4Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M843.798 631.9H673.898V635.5H843.798V631.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M942.998 684.6H673.898V688.2H942.998V684.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M796.801 839.301H732.801V842.901H796.801V839.301Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M944.102 839.301H897.102V842.901H944.102V839.301Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M718.898 699.1H673.898V702.7H718.898V699.1Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M897.101 699.1H725.301V702.7H897.101V699.1Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.398 882.8C880.398 882.8 970.898 847.9 1004.5 790.1C1004.5 790.1 966.498 814.4 924.198 805.7C924.198 805.8 908.198 870.1 880.398 882.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M880.398 882.8C880.398 882.8 970.898 847.9 1004.5 790.1C1004.5 790.1 966.498 814.4 924.198 805.7C924.198 805.8 908.198 870.1 880.398 882.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.12,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.499 1011L661.199 1012.4L638.599 996.2C634.799 993.5 632.499 989.2 632.299 984.6L631.499 966.9L600.699 967L604.499 1011Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M610.802 990.301V990.001C610.602 988.001 612.002 986.301 613.902 986.001L632.002 983.401L631.802 979.801H601.602L604.302 1009.8L629.002 1007.1L620.902 1003.9C615.302 1001.6 611.402 996.301 610.802 990.301Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.5 1009.9H528L532.7 966.801L502.6 966.901L502.5 1009.9Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M508.902 1002.7L509.502 989.4C509.602 987.7 510.902 986.2 512.602 986L531.002 983.2L531.402 979.5L502.702 979.6L502.602 1010.2L508.902 1002.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.801 631.6V984.2H533.901L562.701 696.7C562.901 694.7 564.701 693.2 566.701 693.4C568.401 693.6 569.801 694.9 570.001 696.7L600.601 984.2H633.701L621.701 631.5L500.801 631.6Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.401 994.699L505.201 993.899C511.301 987.899 521.101 988.099 527.101 994.199L527.501 994.699C528.901 996.199 529.801 998.199 529.801 1000.3V1003.6C529.801 1005.5 530.101 1007.4 530.701 1009.3L533.401 1018.3C534.101 1020.5 534.501 1022.7 534.401 1025V1026.1C534.301 1027.9 532.801 1029.3 531.001 1029.2H499.701C497.901 1029.3 496.401 1027.9 496.301 1026.1V1025.7C496.301 1023.1 496.701 1020.4 497.601 1017.9L500.701 1009.1C501.401 1007.1 501.801 1005 501.801 1002.8L501.901 1000.3C502.101 998.199 502.901 996.299 504.401 994.699Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 984.2H535.3L536 977H500V984.2Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M500 984.2H514.8L515.1 977H500V984.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M496.301 1025.7V1026.1C496.401 1027.9 497.901 1029.3 499.701 1029.2H531.001C532.801 1029.3 534.301 1027.9 534.401 1026.1C534.401 1026.1 534.401 1026.1 534.401 1026V1024.8C534.401 1024.4 534.401 1023.9 534.301 1023.5H496.301V1025.7V1025.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.602 1000.9V1023C600.602 1026.6 603.502 1029.4 607.002 1029.5H682.102C683.602 1029.5 684.802 1028.3 684.802 1026.8C684.802 1021.5 681.402 1016.9 676.402 1015.2L659.502 1009.6L638.002 992.9C635.802 991.2 632.602 991.199 630.502 993.099L621.002 1001.2C619.602 1002.4 617.702 1002.8 615.902 1002.2L603.902 998.4C602.502 998 601.102 998.699 600.702 1000.1C600.702 1000.4 600.602 1000.7 600.602 1000.9Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M607.101 1029.5H682.201C683.701 1029.5 684.901 1028.3 684.901 1026.8C684.901 1025.9 684.801 1025 684.601 1024.1H600.801C601.201 1027.2 603.901 1029.5 607.101 1029.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.6 1001.7C637.2 1001.7 636.9 1001.4 637 1001C637 1000.8 637.1 1000.7 637.2 1000.5L641.7 995.6C642 995.3 642.4 995.3 642.7 995.6C643 995.9 643 996.3 642.7 996.6L638.2 1001.5C638 1001.7 637.8 1001.7 637.6 1001.7Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.199 1004.5C640.999 1004.5 640.899 1004.4 640.799 1004.3C640.499 1004 640.499 1003.6 640.799 1003.3L645.299 998.401C645.599 998.101 645.999 998.101 646.299 998.401C646.599 998.701 646.599 999.101 646.299 999.401L641.799 1004.3C641.599 1004.5 641.399 1004.5 641.199 1004.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.799 1007.3C644.399 1007.3 644.099 1007 644.199 1006.6C644.199 1006.4 644.299 1006.3 644.399 1006.1L648.899 1001.2C649.199 1000.9 649.599 1000.9 649.899 1001.2C650.199 1001.5 650.199 1001.9 649.899 1002.2L645.399 1007.1C645.199 1007.3 644.999 1007.4 644.799 1007.3Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.9 1002.2C521.8 1002.2 521.6 1002.2 521.6 1002.1C518 1000.4 513.7 1000.4 510.1 1002.1C509.7 1002.3 509.3 1002.2 509.1 1001.8C508.9 1001.4 509.1 1001 509.4 1000.8C513.5 998.801 518.3 998.801 522.4 1000.8C522.8 1001 522.9 1001.5 522.7 1001.8C522.5 1002 522.2 1002.2 521.9 1002.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.902 1006.2C521.802 1006.2 521.602 1006.2 521.602 1006.1C518.002 1004.4 513.702 1004.4 510.102 1006.1C509.702 1006.3 509.302 1006.2 509.102 1005.8C508.902 1005.4 509.102 1005 509.502 1004.8C513.602 1002.8 518.402 1002.8 522.502 1004.8C522.802 1005 523.002 1005.4 522.802 1005.8C522.502 1006 522.202 1006.2 521.902 1006.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.9 1010.1C521.8 1010.1 521.6 1010.1 521.6 1010C518 1008.3 513.7 1008.3 510.1 1010C509.7 1010.2 509.3 1010.1 509 1009.7C508.7 1009.3 508.9 1008.9 509.3 1008.6H509.4C513.5 1006.6 518.3 1006.6 522.4 1008.6C522.7 1008.8 522.9 1009.2 522.7 1009.6C522.5 1009.9 522.2 1010.1 521.9 1010.1Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M620.298 980.2L587.698 708.7C586.698 700 579.298 693.4 570.498 693.4H566.398C568.298 693.4 569.798 694.8 569.998 696.7L600.498 982.7L620.298 980.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.8 984.2H635L634.5 977H599L599.8 984.2Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.199 482.6L556.899 479.5L576.799 482.6L580.399 663.8H532.699L535.199 482.6Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M599.8 984.2H620.8L620 977H599L599.8 984.2Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.201 482.8L574.901 461C575.401 458.9 575.601 456.7 575.601 454.5C576.001 443.5 576.901 433.5 576.901 433.5C576.901 433.5 540.301 410.5 538.801 438.6L538.301 445.9L535.801 482.7L570.001 500.5L576.201 482.8Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.601 413.8C582.601 413.8 592.801 470.8 563.401 472.2C539.001 473.2 539.701 435.3 539.701 435.3L543.101 408.6L582.601 413.8Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M538.3 447.7C539.6 447.8 540.8 447.5 541.9 446.9L538 453L538.3 447.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M575.698 476.4L574.798 467.6C572.498 470 565.698 473.5 558.098 471.7C554.298 470.8 550.798 468.6 548.298 465.6C548.098 465.4 547.698 465.3 547.498 465.5C547.298 465.7 547.198 466 547.398 466.3C550.698 470.1 555.298 472.6 560.298 473.2C564.798 476.3 570.298 477.4 575.698 476.4Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M568.098 460.801C568.098 460.901 567.998 460.901 568.098 460.801L564.698 461.101C564.298 461.101 563.898 460.801 563.898 460.401C563.898 460.001 564.198 459.601 564.598 459.601C564.598 459.601 564.598 459.601 564.698 459.601L567.998 459.301C568.398 459.301 568.798 459.501 568.798 459.901C568.798 460.501 568.498 460.801 568.098 460.801Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M569.399 457.6C563.299 458.5 560.499 455.2 559.499 453.6C559.299 453.3 559.399 452.8 559.699 452.6C559.999 452.4 560.499 452.5 560.699 452.8C560.699 452.8 560.699 452.8 560.699 452.9C561.599 454.5 564.699 458 571.999 455.6C572.399 455.5 572.799 455.7 572.899 456.1C572.999 456.5 572.799 456.9 572.399 457C571.499 457.2 570.499 457.5 569.399 457.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.001 443.199C562.201 443.199 563.301 442.199 563.301 440.999C563.301 439.799 562.301 438.699 561.101 438.699C559.901 438.699 558.801 439.699 558.801 440.899C558.801 442.199 559.801 443.199 561.001 443.199Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562 441.599C562.2 441.599 562.5 441.399 562.5 441.099C562.5 440.899 562.3 440.699 562 440.699C561.8 440.699 561.5 440.899 561.5 441.099C561.5 441.399 561.8 441.599 562 441.599Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.7 443.3C579.9 443.3 580.9 442.3 580.9 441.1C580.9 439.9 579.9 438.9 578.7 438.9C577.5 438.9 576.5 439.9 576.5 441.1C576.5 442.3 577.5 443.3 578.7 443.3Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.699 441.701C579.899 441.701 580.199 441.501 580.199 441.201C580.199 441.001 579.999 440.801 579.699 440.801C579.499 440.801 579.199 441.001 579.199 441.201C579.299 441.501 579.499 441.701 579.699 441.701Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M570.998 452.099L567.998 452.299C567.598 452.199 567.398 451.799 567.498 451.499C567.598 451.299 567.698 451.099 567.998 450.999L570.998 450.799C571.698 450.699 572.298 449.999 572.198 449.299C572.098 448.599 571.498 448.099 570.798 448.099C570.398 448.099 570.098 447.799 570.098 447.499C569.998 447.099 570.398 446.899 570.698 446.799C572.098 446.699 573.398 447.799 573.598 449.199C573.698 450.699 572.498 451.999 570.998 452.099Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M579.098 509.5L568.398 681.2C568.398 684.5 570.998 687.2 574.298 687.3H574.398H619.998V661.3L579.098 509.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M500.699 976.8L514.999 976.9L522.699 676H500.799L500.699 976.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.2 493.999C623.7 498.499 628.8 507.799 630.4 516.499L639.8 578.099L618.7 601.099L622 639.199L628.3 771.099C628.3 771.699 627.9 772.199 627.3 772.299C627.3 772.299 627.3 772.299 627.2 772.299H570L578 545.499L577 482.199L612.2 493.999Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.301 533C592.301 532.9 590.001 523.4 585.701 509.5L584.801 511.6C587.101 518.7 589.101 526 590.601 533.3L592.301 533Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.598 534.4C600.098 537.7 598.598 541.6 595.298 543.1C591.998 544.6 588.098 543.1 586.598 539.8C585.098 536.5 586.598 532.6 589.898 531.1C593.198 529.6 597.098 531.1 598.598 534.4Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M596.298 535.7C597.098 537.8 596.098 540.1 593.998 540.9C591.898 541.7 589.598 540.7 588.798 538.6C587.998 536.5 588.998 534.2 591.098 533.4H591.198C593.198 532.6 595.498 533.7 596.298 535.7Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.6 482.5L579 544.4L576.3 772.3L499.2 771.5C498.6 771.5 498.1 771 498.1 770.4L500.3 620.9L482.6 525.3C481.9 516.9 486 503.9 494.6 498.4C497.1 496.9 536.6 482.5 536.6 482.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.499 615.201C619.499 615.201 626.199 621.001 634.099 620.801C634.099 620.801 644.199 620.801 646.299 610.701L647.599 598.301L618.699 598.601L619.499 615.201Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.102 609.201L595.402 608.301C595.402 608.301 593.502 608.901 594.502 610.201C594.902 610.701 595.502 611.101 596.202 611.101L616.202 613.701L607.102 609.201Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583 415.6C581.9 398.1 551.5 392 538.5 406C532.8 412.1 530 425.4 532.8 433.3C534.1 435.4 535.4 434.4 535.1 437.2C535 438.2 535.3 439.3 535.9 440.1C545.4 444.5 549.1 427.2 546.7 419.9C544.7 413.7 554.2 411.5 558.9 413.6C567 417.1 576.4 420.1 580.5 414.6C580.8 414.2 581.4 414.1 581.8 414.4L581.9 414.5L583 415.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.798 539.6C564.498 559.9 564.398 565.2 562.998 567.9C561.898 569.8 560.398 571.4 558.598 572.6L557.798 571.3L558.198 572L557.798 571.3C559.398 570.2 560.698 568.8 561.598 567.1C562.598 565.2 562.998 560.2 554.398 540.1L555.798 539.6Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.098 542.2C540.298 558.8 540.498 567.7 542.998 570.1C544.398 571.4 546.098 572.4 547.898 573L547.498 574.5C545.398 573.9 543.498 572.7 541.898 571.2C538.998 568.2 538.598 559.8 540.598 542L542.098 542.2Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M555.798 539.6C564.498 559.9 564.398 565.2 562.998 567.9C561.898 569.8 560.398 571.4 558.598 572.6L557.798 571.3L558.198 572L557.798 571.3C559.398 570.2 560.698 568.8 561.598 567.1C562.598 565.2 562.998 560.2 554.398 540.1L555.798 539.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M542.098 542.2C540.298 558.8 540.498 567.7 542.998 570.1C544.398 571.4 546.098 572.4 547.898 573L547.498 574.5C545.398 573.9 543.498 572.7 541.898 571.2C538.998 568.2 538.598 559.8 540.598 542L542.098 542.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.198 573.4L545.598 572.4C545.798 571.8 546.498 571.5 546.998 571.7L549.898 572.8C550.498 573 550.798 573.7 550.598 574.2L550.198 575.2C549.998 575.8 549.298 576.1 548.798 575.9L545.898 574.8C545.298 574.6 544.998 574 545.198 573.4Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 541.399C540.2 537.799 540.6 534.199 541.2 530.599C541.6 528.999 542.5 527.499 543.7 526.399C544 526.299 543.5 523.599 543 521.499C542.6 519.599 542 517.399 542.4 516.699C542.9 515.999 543.8 515.799 544.5 516.299C545.1 516.799 545.5 519.099 545.8 520.999C546.2 523.199 546.7 525.799 547 525.799C548.5 526.499 549.8 527.499 550.8 528.799C552.8 531.999 554.5 535.299 556 538.699C556.8 540.899 556.1 541.299 555.5 541.599C554.6 542.099 554 541.499 552.9 539.099C551.2 535.299 548.7 528.799 546 529.199C543.3 529.899 543.2 537.099 542.9 541.199C542.7 543.799 542.2 544.099 541.2 543.999C540.6 543.899 539.8 543.699 540 541.399Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.604 508.466L542.109 508.59L542.73 516.064L544.225 515.94L543.604 508.466Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.3 574.299L555.7 573.399C555.3 572.899 555.4 572.199 555.9 571.799L558.4 569.899C558.9 569.499 559.6 569.599 560 570.099L560.6 570.999C561 571.499 560.9 572.199 560.4 572.599L557.9 574.499C557.3 574.799 556.6 574.799 556.3 574.299Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M507.899 632.9L500.399 620.9L498.199 770.3C498.199 770.9 498.699 771.4 499.299 771.4L511.099 771.5L511.799 771.2L507.899 632.9Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.599 558.601C590.299 562.901 599.599 574.001 599.599 574.001L602.399 572.601L589.299 556.301C588.799 555.601 587.799 555.401 586.999 555.901C586.099 556.401 585.799 557.501 586.299 558.301C586.399 558.401 586.499 558.501 586.599 558.601Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M586.599 558.601C590.299 562.901 599.599 574.001 599.599 574.001L602.399 572.601L589.299 556.301C588.799 555.601 587.799 555.401 586.999 555.901C586.099 556.401 585.799 557.501 586.299 558.301C586.399 558.401 586.499 558.501 586.599 558.601Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.898 579.3L589.698 571.1C591.098 569.3 593.398 568.6 595.498 569.2C595.698 569.3 595.798 569.3 595.998 569.4C597.398 570.1 603.498 572.7 606.198 573.8C606.998 574.1 607.698 574.8 607.998 575.6L609.798 579.9C610.198 580.9 609.798 582 608.998 582.5L607.398 590.6L604.698 591.3L602.998 596.8C602.998 596.8 600.598 597.4 599.898 596.7L599.198 596L598.398 594.3L592.998 598.2L585.498 599.7L581.898 579.3Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M597.301 574.5C597.301 574.5 604.801 577.1 606.901 578.7C607.801 579.4 609.401 581.9 608.901 582.8",
    stroke: "black",
    strokeWidth: 0.59,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.59px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M596.5 579.801C596.5 579.801 609.5 584.901 607.4 590.601",
    stroke: "black",
    strokeWidth: 0.59,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.59px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M594.801 586.801L600.801 588.501C600.801 588.501 604.601 589.701 604.201 592.701L603.101 596.701",
    stroke: "black",
    strokeWidth: 0.59,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.59px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M579 547.801L580.4 769.801",
    stroke: "black",
    strokeWidth: 1.12,
    strokeMiterlimit: 10,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeMiterlimit: 10,
      strokeWidth: "1.12px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M619.999 575.8L618.699 539.7C618.699 539.3 618.899 539 619.299 539C619.699 539 619.999 539.2 619.999 539.6L623.399 576L619.999 575.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M494.7 498.5C486 504 481.9 517 482.7 525.3L500.4 620.9L500.3 629.1C502.4 631.1 505.1 632.5 507.9 633C511.4 633.5 515 633.2 518.4 632.2C532.8 627.4 556.2 616.9 578.4 605.5L578.5 599.9L520.7 625.5L520.4 625.6C511.3 627.7 502.2 621.9 500.2 612.8C500.1 612.2 499.9 611.5 499.9 610.9L488.9 528.2C485.9 504.9 494.7 498.5 494.7 498.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M620.5 615.999L619.5 604.799L622.9 601.699L623.7 611.799C626.1 616.599 630.8 619.899 636.1 620.599C636 620.599 628.2 622.399 620.5 615.999Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M530.801 484.499L531.301 501.099H537.101L533.401 505.799L578.901 546.299V545.199L532.701 484.199L530.801 484.499Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.2 476.4L536.7 482.4L581.4 547.7L536.3 504.8L540.1 499.5H532.8L531.8 486C531.7 484.8 532 483.6 532.6 482.5L536.2 476.4Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M583.5 484.799L589.2 497.199L585.4 498.999L588.4 500.199L580.2 546.299L579 547.799L580.8 496.299L581.9 484.199L583.5 484.799Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 478.1L576.8 482.5L579 547.7L586.9 500.5L582.1 499.1L586.9 496.8L582.1 484.7C582 484.3 581.7 484 581.5 483.7L576 478.1Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M521 538.801L525.2 543.701L529.2 588.801L582.4 574.801L584.4 581.501L522.8 595.001L521 538.801Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.602 525.301L490.802 616.201C491.502 624.401 496.702 632.701 504.802 634.001C508.302 634.501 511.902 634.201 515.302 633.201C532.202 627.601 564.402 613.101 589.602 599.601L582.902 577.701L526.202 593.901L522.802 539.901L482.602 525.301Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M588.3 595.4L516.5 626.4L516.2 626.5C506.3 628.8 497.7 621.8 496.6 611.8L488.6 528.1C488.6 528 488.6 527.9 488.6 527.7L482.5 525.4L490.7 616.3C491 620.5 492.5 624.5 495 627.8C495.9 629 496.9 630.1 498.1 631L498.2 631.1C498.6 631.4 498.9 631.6 499.3 631.9C499.4 631.9 499.4 632 499.5 632C499.9 632.2 500.2 632.4 500.6 632.6C500.7 632.7 500.9 632.7 501 632.8C501.3 633 501.6 633.1 502 633.2L502.7 633.4C502.9 633.5 503.2 633.6 503.5 633.6C504 633.7 504.5 633.8 505 633.9C508.2 634.4 511.4 634.1 514.5 633.1C531.4 627.5 564.6 613 589.8 599.5L588.3 595.4Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M526.199 593.9L521.799 595.9C521.499 596 521.199 595.9 520.999 595.6C520.899 595.4 520.899 595.1 521.099 595L525.999 589.5L526.199 593.9Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.501 568.301L561.801 614.901L562.101 617.501L611.501 617.801L669.301 572.701L669.201 570.201L617.501 568.301Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M669.301 572.701L617.801 570.901L562.101 617.501L561.801 614.901L617.501 568.301L669.201 570.201L669.301 572.701Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.301 569.001L639.801 565.801L660.001 566.501L656.301 569.701L636.301 569.001Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M636.301 569.001L639.801 565.801L660.001 566.501L656.301 569.701L636.301 569.001Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.398 569L639.798 566.9L658.898 567.6L656.298 569.7L637.398 569Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.799 581.1C640.699 580.1 642.099 579.7 643.499 579.9C645.299 580.2 646.999 580.7 648.599 581.4C649.899 582.2 652.799 586 653.799 587.4C654.099 587.8 654.199 588.2 654.099 588.7C653.999 589.8 653.399 590.8 652.399 591.3C652.499 592.1 652.499 592.8 652.399 593.6C652.299 595.5 652.399 596.6 649.699 597.9C649.699 597.9 649.599 601 648.499 601.7C647.799 602.2 647.099 602.6 646.299 602.9C646.299 602.9 645.699 606.3 641.199 605.7L638.599 606.5C637.399 606.9 635.999 606.9 634.799 606.5C632.399 605.8 628.799 604.6 629.599 604C630.699 603 632.599 597.8 632.599 597.8C632.599 597.8 626.699 592.3 626.999 590.8C627.399 589.7 628.099 588.8 628.999 588.1C628.999 588.1 629.099 585.3 631.399 585.3C631.399 585.3 632.399 583.1 634.199 583.2C635.999 583.3 647.199 589 647.199 589L643.199 584.7C643.199 584.7 638.899 583.5 639.199 582C639.399 581.7 639.599 581.3 639.799 581.1Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M631.898 586L644.798 593.3",
    stroke: "black",
    strokeWidth: 0.84,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.84px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M629.102 588.801L639.202 595.601",
    stroke: "black",
    strokeWidth: 0.84,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    style: {
      baselineShift: 0,
      opacity: 0.15,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.84px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M524 655.699H560V689.899C560 695.899 555.2 700.699 549.2 700.699H534.8C528.8 700.699 524 695.799 524 689.899V655.699V655.699Z",
    stroke: "black",
    strokeWidth: 1.69,
    strokeMiterlimit: 10,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      stroke: "rgb(0, 0, 0)",
      strokeMiterlimit: 10,
      strokeWidth: "1.69px",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "mask-in-svg",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M533.301 446.2L537.401 432.4L549.001 444.4L543.601 458.3L533.301 446.2ZM537.501 434L534.401 446.1L543.401 455.5L547.701 444.4L537.501 434Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "mask-in-svg",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M547.802 442.301C559.002 447.101 571.102 449.201 583.202 448.401C583.202 448.401 582.002 467.001 568.002 471.501C568.002 471.501 551.502 475.001 542.602 457.001C542.602 456.901 547.002 449.401 547.802 442.301Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "mask-in-svg",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M544.102 453.901C545.902 450.201 547.202 446.301 547.802 442.201C559.002 447.001 571.102 449.101 583.202 448.301C583.202 448.301 582.702 457.701 576.902 464.801C576.902 464.901 558.002 471.801 544.102 453.901Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "mask-in-svg",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M583.201 448.401L582.201 455.401C569.801 458.101 556.801 455.601 546.301 448.501C546.901 446.701 547.401 444.901 547.601 443.001L547.801 442.301C559.001 447.001 571.101 449.101 583.201 448.401Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M539.698 433.201C539.698 433.201 537.898 428.101 532.498 430.401C526.398 433.101 527.698 446.901 537.998 447.701C543.398 448.201 542.298 445.001 541.398 440.801L539.698 433.201Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.301 433.901L575.501 433.601H574.201L565.701 433.401H565.601L554.601 433.101C552.801 433.001 551.301 434.401 551.301 436.201L551.201 438.701C551.101 443.601 555.001 447.601 559.901 447.601C564.601 447.701 568.601 443.901 568.801 439.201L568.901 436.701C568.901 436.001 568.701 435.301 568.201 434.701L571.601 434.801C571.101 435.401 570.901 436.101 570.901 436.801L570.801 439.301C570.601 444.201 574.301 448.301 579.201 448.501C584.101 448.701 588.201 445.001 588.401 440.101C588.401 440.001 588.401 439.901 588.401 439.801L588.501 437.301C588.601 435.501 587.301 434.001 585.501 433.901C585.401 433.901 585.401 433.901 585.301 433.901ZM567.501 436.601L567.401 439.101C567.301 443.201 563.901 446.501 559.701 446.401C555.601 446.301 552.301 442.901 552.401 438.701L552.501 436.201C552.501 435.101 553.401 434.301 554.501 434.301L565.501 434.601H565.601C566.701 434.701 567.501 435.501 567.501 436.601C567.601 436.601 567.601 436.601 567.501 436.601ZM587.101 439.701C587.001 443.801 583.601 447.101 579.401 447.001C575.301 446.901 572.001 443.501 572.101 439.301L572.201 436.801C572.201 435.701 573.101 434.901 574.201 434.901H575.501L585.301 435.201C586.401 435.201 587.201 436.101 587.201 437.201L587.101 439.701Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M532.201 433.999C533.001 433.299 534.101 432.999 535.201 433.199C536.201 433.499 537.101 434.099 537.501 435.099C538.201 436.199 538.501 437.499 538.501 438.899L538.601 440.099C538.601 440.399 538.301 440.699 538.001 440.699C537.701 440.699 537.401 440.399 537.401 440.099L537.301 438.899C537.301 437.799 537.001 436.699 536.501 435.799C536.201 435.199 535.601 434.699 535.001 434.399C534.301 434.299 533.601 434.499 533.001 434.899C532.701 435.099 532.301 434.999 532.101 434.699C531.901 434.599 532.001 434.199 532.201 433.999Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.7 871.8V1011.8C1091.7 1021.8 1086.3 1030 1079.4 1030L1029.5 1029.9H979.598C973.298 1030 967.398 1021.8 967.398 1011.8V871.8C967.398 861.8 972.298 854 979.598 853.7H990.598V840.5H1029.6V840.4L1068.5 840.5V853.7H1079.5C1087.3 854 1091.7 861.8 1091.7 871.8Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.5 901.5H971.699V990H1087.5V901.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084 987.4H975.199V904H1084V987.4ZM976.199 986.4H1083V905H976.099L976.199 986.4Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1062.1 840.5V853.7H1067.1C1071.7 853.7 1075.4 861.8 1075.4 871.8V1011.8C1075.4 1021.6 1071.8 1029.7 1067.4 1030H1080.5C1085.1 1030 1091.8 1021.8 1091.8 1011.8V871.8C1091.8 863.5 1088.7 857.4 1083.7 854.8C1082.1 854 1080.4 853.7 1078.7 853.7H1068.5V840.5H1062.1V840.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1001.7 840.5V853.7H996.7C992.1 853.7 988.4 861.8 988.4 871.8V1011.8C988.4 1021.6 992 1029.7 996.4 1030H983.3C978.7 1030 972 1021.8 972 1011.8V871.8C972 863.5 975.1 857.4 980.1 854.8C981.7 854 983.4 853.7 985.1 853.7H995.3V840.5H1001.7V840.5Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.999 824H1072C1073.3 824 1074.3 825 1074.3 826.3V845.3C1074.3 846.6 1073.3 847.6 1072 847.6H986.999C985.699 847.6 984.699 846.6 984.699 845.3V826.3C984.699 825.1 985.699 824 986.999 824Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1062.1 851.301H991V853.701H1062.1V851.301Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1067.9 824H1054.8V846.9H1067.9V824Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1029.6 917H1013.6V943H1029.6V917Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.6 943H1029.6V917H1045.6V943ZM1030.2 942.3H1044.9V917.6H1030.2V942.3Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.2 930V939C1022.2 939 1018.2 935 1018.2 930C1018.2 925 1022.2 921 1027.2 921V930Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.6 930.301V939.301C1037.6 939.301 1041.6 935.301 1041.6 930.301C1041.6 925.301 1037.6 921.301 1032.6 921.301V930.301Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.6 954H991.602V956H1067.6V954Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.6 962H991.602V964H1067.6V962Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1067.6 954H991.602V956H1067.6V954Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1067.6 962H991.602V964H1067.6V962Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.3 975H982.301V980H1003.3V975Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M990.001 844.999C989.601 844.999 989.301 844.799 989.301 844.699V826.499C989.301 826.299 989.601 826.199 990.001 826.199C990.401 826.199 990.701 826.399 990.701 826.499V844.699C990.601 844.799 990.301 844.999 990.001 844.999Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M996.501 844.999C996.101 844.999 995.801 844.799 995.801 844.699V826.499C995.801 826.299 996.101 826.199 996.501 826.199C996.901 826.199 997.201 826.399 997.201 826.499V844.699C997.201 844.799 996.901 844.999 996.501 844.999Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1003.1 844.999C1002.7 844.999 1002.4 844.799 1002.4 844.699V826.499C1002.4 826.299 1002.7 826.199 1003.1 826.199C1003.5 826.199 1003.8 826.399 1003.8 826.499V844.699C1003.7 844.799 1003.5 844.999 1003.1 844.999Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1009.6 844.999C1009.2 844.999 1008.9 844.799 1008.9 844.699V826.499C1008.9 826.299 1009.2 826.199 1009.6 826.199C1010 826.199 1010.3 826.399 1010.3 826.499V844.699C1010.3 844.799 1010 844.999 1009.6 844.999Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1016.2 844.999C1015.8 844.999 1015.5 844.799 1015.5 844.699V826.499C1015.5 826.299 1015.8 826.199 1016.2 826.199C1016.6 826.199 1016.9 826.399 1016.9 826.499V844.699C1016.8 844.799 1016.6 844.999 1016.2 844.999Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1022.8 844.999C1022.4 844.999 1022.1 844.799 1022.1 844.699V826.499C1022.1 826.299 1022.4 826.199 1022.8 826.199C1023.2 826.199 1023.5 826.399 1023.5 826.499V844.699C1023.4 844.799 1023.1 844.999 1022.8 844.999Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1029.3 844.999C1028.9 844.999 1028.6 844.799 1028.6 844.699V826.499C1028.6 826.299 1028.9 826.199 1029.3 826.199C1029.7 826.199 1030 826.399 1030 826.499V844.699C1030 844.799 1029.7 844.999 1029.3 844.999Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1035.9 844.999C1035.5 844.999 1035.2 844.799 1035.2 844.699V826.499C1035.2 826.299 1035.5 826.199 1035.9 826.199C1036.3 826.199 1036.6 826.399 1036.6 826.499V844.699C1036.5 844.799 1036.2 844.999 1035.9 844.999Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1042.4 844.999C1042 844.999 1041.7 844.799 1041.7 844.699V826.499C1041.7 826.299 1042 826.199 1042.4 826.199C1042.8 826.199 1043.1 826.399 1043.1 826.499V844.699C1043.1 844.799 1042.8 844.999 1042.4 844.999Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1049 844.999C1048.6 844.999 1048.3 844.799 1048.3 844.699V826.499C1048.3 826.299 1048.6 826.199 1049 826.199C1049.4 826.199 1049.7 826.399 1049.7 826.499V844.699C1049.6 844.799 1049.3 844.999 1049 844.999Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1055.5 844.999C1055.1 844.999 1054.8 844.799 1054.8 844.699V826.499C1054.8 826.299 1055.1 826.199 1055.5 826.199C1055.9 826.199 1056.2 826.399 1056.2 826.499V844.699C1056.2 844.799 1055.9 844.999 1055.5 844.999Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1062.1 844.999C1061.7 844.999 1061.4 844.799 1061.4 844.699V826.499C1061.4 826.299 1061.7 826.199 1062.1 826.199C1062.5 826.199 1062.8 826.399 1062.8 826.499V844.699C1062.8 844.799 1062.5 844.999 1062.1 844.999Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1068.7 844.999C1068.3 844.999 1068 844.799 1068 844.699V826.499C1068 826.299 1068.3 826.199 1068.7 826.199C1069.1 826.199 1069.4 826.399 1069.4 826.499V844.699C1069.3 844.799 1069 844.999 1068.7 844.999Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1159.1 1029.8H1108.6C1106.4 1029.9 1104.6 1028.1 1104.5 1025.9C1104.5 1025.9 1104.5 1025.9 1104.5 1025.8L1104.3 893.9H1163L1163.2 1025.7C1163.2 1027.9 1161.5 1029.7 1159.2 1029.7C1159.2 1029.8 1159.1 1029.8 1159.1 1029.8Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 81, 72)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.6 887.301H1110.6C1108.9 887.301 1107.6 888.601 1107.6 890.301V893.201H1159.6V890.301C1159.6 888.701 1158.3 887.301 1156.6 887.301Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.8 891.9H1165.3C1166.8 891.9 1167.9 893.1 1167.9 894.5V920.6C1167.9 922.1 1166.7 923.2 1165.3 923.2H1101.8C1100.3 923.2 1099.2 922 1099.2 920.6V894.5C1099.2 893 1100.4 891.9 1101.8 891.9Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(52, 2, 132)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1157.2 887.301H1147V890.301H1107.6V891.901H1159.6V890.401C1159.9 889.101 1159 887.701 1157.7 887.501C1157.5 887.401 1157.3 887.301 1157.2 887.301Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1168 920.6V894.5C1168 893 1166.8 891.9 1165.3 891.9H1149.5V923.3H1165.3C1166.8 923.3 1168 922.1 1168 920.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1103.5 921C1103.2 921 1103 920.8 1103 920.5V894C1103 893.7 1103.2 893.5 1103.5 893.5C1103.8 893.5 1104 893.7 1104 894V920.4C1104 920.7 1103.8 921 1103.5 921Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1108.5 921C1108.2 921 1108 920.8 1108 920.5V894C1108 893.7 1108.2 893.5 1108.5 893.5C1108.8 893.5 1109 893.7 1109 894V920.4C1109 920.7 1108.8 921 1108.5 921Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1113.5 921C1113.2 921 1113 920.8 1113 920.5V894C1113 893.7 1113.2 893.5 1113.5 893.5C1113.8 893.5 1114 893.7 1114 894V920.4C1114 920.7 1113.8 921 1113.5 921Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1118.5 921C1118.2 921 1118 920.8 1118 920.5V894C1118 893.7 1118.2 893.5 1118.5 893.5C1118.8 893.5 1119 893.7 1119 894V920.4C1119 920.7 1118.8 921 1118.5 921Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1123.5 921C1123.2 921 1123 920.8 1123 920.5V894C1123 893.7 1123.2 893.5 1123.5 893.5C1123.8 893.5 1124 893.7 1124 894V920.4C1124 920.7 1123.8 921 1123.5 921Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1128.5 921C1128.2 921 1128 920.8 1128 920.5V894C1128 893.7 1128.2 893.5 1128.5 893.5C1128.8 893.5 1129 893.7 1129 894V920.4C1129 920.7 1128.8 921 1128.5 921Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1133.5 921C1133.2 921 1133 920.8 1133 920.5V894C1133 893.7 1133.2 893.5 1133.5 893.5C1133.8 893.5 1134 893.7 1134 894V920.4C1134 920.7 1133.8 921 1133.5 921Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1138.5 921C1138.2 921 1138 920.8 1138 920.5V894C1138 893.7 1138.2 893.5 1138.5 893.5C1138.8 893.5 1139 893.7 1139 894V920.4C1139 920.7 1138.8 921 1138.5 921Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1143.5 921C1143.2 921 1143 920.8 1143 920.5V894C1143 893.7 1143.2 893.5 1143.5 893.5C1143.8 893.5 1144 893.7 1144 894V920.4C1144 920.7 1143.8 921 1143.5 921Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1148.5 921C1148.2 921 1148 920.8 1148 920.5V894C1148 893.7 1148.2 893.5 1148.5 893.5C1148.8 893.5 1149 893.7 1149 894V920.4C1149 920.7 1148.8 921 1148.5 921Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1153.5 921C1153.2 921 1153 920.8 1153 920.5V894C1153 893.7 1153.2 893.5 1153.5 893.5C1153.8 893.5 1154 893.7 1154 894V920.4C1154 920.7 1153.8 921 1153.5 921Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1158.5 921C1158.2 921 1158 920.8 1158 920.5V894C1158 893.7 1158.2 893.5 1158.5 893.5C1158.8 893.5 1159 893.7 1159 894V920.4C1159 920.7 1158.8 921 1158.5 921Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1163.5 921C1163.2 921 1163 920.8 1163 920.5V894C1163 893.7 1163.2 893.5 1163.5 893.5C1163.8 893.5 1164 893.7 1164 894V920.4C1164 920.7 1163.8 921 1163.5 921Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1159.8 947.801H1107.3V987.901H1159.8V947.801Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.2 986.7H1108.9V948.9H1158.2V986.7ZM1109.3 986.3H1157.8V949.4H1109.3V986.3Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.5 954.801H1126.3V966.601H1133.5V954.801Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.8 966.601H1133.6V954.801H1140.8V966.601ZM1133.8 966.301H1140.5V955.101H1133.8V966.301Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.5 960.7V964.8C1130.2 964.8 1128.4 963 1128.4 960.7C1128.4 958.5 1130.2 956.6 1132.5 956.6V960.7Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.9 960.799V964.899C1137.2 964.799 1138.9 962.899 1138.8 960.599C1138.7 958.499 1137 956.799 1134.9 956.699V960.799Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.8 971.6H1116.3V972.5H1150.8V971.6Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.8 975.199H1116.3V976.099H1150.8V975.199Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1150.8 971.6H1116.3V972.5H1150.8V971.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1150.8 975.199H1116.3V976.099H1150.8V975.199Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.6 981.1H1112.1V983.4H1121.6V981.1Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1146.3 1029.8H1159.2C1161.4 1029.8 1163.2 1028 1163.2 1025.8L1163 923H1150.3V1025.2C1150.3 1026.9 1149.2 1028.5 1147.6 1029.2L1146.3 1029.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1119.2 1029.8H1111.3C1109.1 1029.8 1107.3 1028 1107.3 1025.8L1107.5 923H1115.2V1025.2C1115.2 1026.9 1116.3 1028.5 1117.9 1029.2L1119.2 1029.8Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.9 461.101L410.5 453.701L418.8 434.301L436.2 441.701C441.3 443.901 443.7 449.801 441.5 454.901L441.1 455.701C438.9 461.001 433 463.301 427.9 461.101C427.9 461.201 427.9 461.201 427.9 461.101Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M427.9 461.101L410.5 453.701L418.8 434.301L436.2 441.701C441.3 443.901 443.7 449.801 441.5 454.901L441.1 455.701C438.9 461.001 433 463.301 427.9 461.101C427.9 461.201 427.9 461.201 427.9 461.101Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.702 445.6C441.102 447.6 440.902 449.7 440.102 451.5L439.702 452.3C437.502 457.4 431.602 459.8 426.502 457.6L411.602 451.2L410.602 453.6L428.002 461C433.102 463.2 439.002 460.8 441.202 455.7L441.602 454.9C442.802 452 442.502 448.5 440.702 445.6Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M440.702 445.6C441.102 447.6 440.902 449.7 440.102 451.5L439.702 452.3C437.502 457.4 431.602 459.8 426.502 457.6L411.602 451.2L410.602 453.6L428.002 461C433.102 463.2 439.002 460.8 441.202 455.7L441.602 454.9C442.802 452 442.502 448.5 440.702 445.6Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.402 426.9L418.802 434.3L410.502 453.7L393.102 446.3C388.002 444.1 385.602 438.2 387.802 433.1L388.202 432.3C390.302 427.1 396.302 424.7 401.402 426.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M388.602 431.5C388.502 431.8 388.302 432 388.202 432.3L387.802 433.1C385.602 438.2 388.002 444.1 393.102 446.3L410.502 453.7L411.502 451.3L394.102 443.9C389.302 441.8 386.902 436.4 388.602 431.5Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.6 784.799L1214.8 799.499L1198.4 786.299L1210.2 771.599C1213.7 767.299 1220 766.599 1224.4 769.999L1225.1 770.599C1229.4 774.199 1230.1 780.499 1226.6 784.799Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1226.6 784.799L1214.8 799.499L1198.4 786.299L1210.2 771.599C1213.7 767.299 1220 766.599 1224.4 769.999L1225.1 770.599C1229.4 774.199 1230.1 780.499 1226.6 784.799Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.1 768.4C1217.1 768.5 1219.1 769.299 1220.6 770.599L1221.3 771.2C1225.6 774.7 1226.4 781 1222.9 785.4L1212.7 798.099L1214.7 799.799L1226.5 785.099C1230 780.799 1229.3 774.4 1224.9 770.9L1224.2 770.299C1221.8 768.099 1218.3 767.4 1215.1 768.4Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(40, 63, 255)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1215.1 768.4C1217.1 768.5 1219.1 769.299 1220.6 770.599L1221.3 771.2C1225.6 774.7 1226.4 781 1222.9 785.4L1212.7 798.099L1214.7 799.799L1226.5 785.099C1230 780.799 1229.3 774.4 1224.9 770.9L1224.2 770.299C1221.8 768.099 1218.3 767.4 1215.1 768.4Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.6 801.2L1198.4 786.5L1214.8 799.7L1203 814.4C1199.5 818.7 1193.2 819.4 1188.8 816L1188.1 815.4C1183.8 812 1183.1 805.6 1186.6 801.2C1186.6 801.3 1186.6 801.3 1186.6 801.2Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1187.5 814.8C1187.7 815 1187.9 815.2 1188.1 815.4L1188.8 816C1193.1 819.5 1199.5 818.8 1203 814.4L1214.8 799.7L1212.8 798L1201 812.7C1197.7 816.8 1191.9 817.7 1187.5 814.8Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualLab);
export default __webpack_public_path__ + "static/media/VirtualLab.30c9609e9aae6782ab68c0f386e966b6.svg";
export { ForwardRef as ReactComponent };